module.exports = __webpack_public_path__ + "static/media/12_BG_Red.fed14862.png";